import threeSixtyAnimation from "./360-animation.gif";
import threeSixtyCam from "./360-grad-kamera.jpg";
import threeSixtyRoomTab from "./360-tour-room-tab.png";
import adTech from "./examples/ad-tech.png";
import fashionStore from "./examples/fashion-store.jpeg";
import hoodHouseHH from "./examples/hood-house-hamburg.png";
import hotelDeichgraph from "./examples/hotel-deichgraph.jpeg";
import house from "./examples/house.jpeg";
import lightTower from "./examples/light-tower-balje.jpg";
import oneRoom from "./examples/one-room-apt.jpeg";
import twoRoom from "./examples/two-room-apt.jpeg";
import floorPlanTwo from "./grundriss-mit-moebelierung.png";
import matterportFlat from "./matterport-flat.svg";
import matterportHotel from "./matterport-hotel.svg";
import matterportCam from "./matterport-kamera.jpg";
import matterportMuseum from "./matterport-museum.svg";
import matterportProperty from "./matterport-property.svg";
import matterportRetail from "./matterport-retail.svg";
import matterportYacht from "./matterport-yacht.svg";
import floorPlan from "./schwarzer-grundriss-mit-nordpfeil.png";
import virtualMarketing from "./virtual-marketing.jpg";
import roomExample from "./zimmer-mit-couch.jpg";

export {
  adTech,
  fashionStore,
  floorPlan,
  floorPlanTwo,
  hoodHouseHH,
  hotelDeichgraph,
  house,
  lightTower,
  matterportCam,
  matterportFlat,
  matterportHotel,
  matterportMuseum,
  matterportProperty,
  matterportRetail,
  matterportYacht,
  oneRoom,
  roomExample,
  threeSixtyAnimation,
  threeSixtyCam,
  threeSixtyRoomTab,
  twoRoom,
  virtualMarketing,
};
